<template>
  <div class="h-full flex flex-col">
    <div class="flex mb-10px flex-wrap">
      <el-input
        size="small"
        class="mr-10px !w-50  mb-10px"
        placeholder="请输入关键字"
        v-model="searchData.keywords"
        clearable
      ></el-input>
      <el-input-number
        controls-position="right"
        size="small"
        class="mr-10px !w-50 mb-10px"
        :min="1"
        :precision="0"
        v-model="searchData.inspectionCycle"
        placeholder="请选择排查周期"
        clearable
      ></el-input-number>
      <el-select
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择排查周期单位"
        v-model="searchData.unitCycle"
        clearable
      >
        <el-option
          v-for="item in unitCycleList"
          :key="item.code"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-select
        v-model="searchData.inspectionType"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择排查类型"
        clearable
      >
        <el-option
          v-for="item in checkTypeList"
          :key="item.code"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-select
        v-model="searchData.deadlinePersonId"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择排查人"
        clearable
        filterable
      >
        <el-option
          v-for="item in userList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-button class="mb-10px" size="small" type="primary" @click="searchList()">搜索</el-button>
      <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
      <el-button
        class="mb-10px"
        size="small"
        :disabled="!$hasAccess('create')"
        @click="handleEvent(null, 'create')"
        >批量设置任务</el-button
      >
    </div>
    <div class="flex-auto h-0px">
      <el-table
        :data="tableData"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="loading"
        @selection-change="handleSelection"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="排查项目"
          width="180"
          prop="screeningItems"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="项目编号"
          width="120"
          prop="projectCode"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="排查内容"
          width="120"
          prop="troubleshootingContent"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="排查标准"
          prop="screeningCriteria"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="组织级别" prop="organizationLevel" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ controlHierarchyListMap(scope.row.organizationLevel) }}
          </template>
        </el-table-column>
        <el-table-column label="排查周期" prop="inspectionCycle" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.inspectionCycle }}{{ unitCycleListMap(scope.row.unitCycle) }}
          </template>
        </el-table-column>
        <el-table-column label="排查类型" prop="screeningType" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ checkTypeListMap(scope.row.screeningType) }}
          </template>
        </el-table-column>
        <el-table-column
          label="初次排查时间"
          prop="initialInvestigationTime"
          show-overflow-tooltip
          width="180"
        >
          <template slot-scope="scope">
            {{
              scope.row.initialInvestigationTime &&
                dayjs(scope.row.initialInvestigationTime).format('YYYY-MM-DD HH:mm:ss')
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="排查截至时间"
          prop="deadlineForTime"
          show-overflow-tooltip
          width="180"
        >
          <template slot-scope="scope">
            {{
              scope.row.deadlineForTime &&
                dayjs(scope.row.deadlineForTime).format('YYYY-MM-DD HH:mm:ss')
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="排查人"
          prop="deadlinePersonName"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="计划状态"
          width="180"
          fixed="right"
          prop="planStatus"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.planStatus"
              :active-value="true"
              :inactive-value="false"
              active-text="启用"
              inactive-text="停用"
              @change="(value) => changeValues(value, scope.$index, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="220">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="searchList"
        @current-change="findList"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="total"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>

    <!-- 设备计划表单 -->
    <timing-base-form
      v-if="formDialog"
      :formProps="formProps"
      :formData="formData"
      @refreshList="
        formDialog = false
        findList()
      "
      @cancel="formDialog = false"
    ></timing-base-form>

    <!-- 计划分配 -->
    <el-dialog
      v-if="dialogShow"
      :close-on-click-modal="false"
      title="新增"
      :visible.sync="dialogShow"
      class="small-dialog"
      v-dialogDrag
    >
      <task-unit-config
        ref="taskUnitAdd"
        :columns="24"
        oper="batch"
        :currentRow="selectionData"
        @cancel="dialogShow = false"
      ></task-unit-config>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button size="small" type="primary" @click="save()">保存</el-button>
        <el-button size="small" @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import { HiddenDangerScheduledTaskApi } from '@wiz-api/double-prevention-management'
import { UserApi } from '@wiz-api/abp-identity'
import utils from '@/components/safety/enumField/utils'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import TimingBaseForm from './TimingBaseForm'
import TaskUnitConfig from '../TimingTask/TaskUnitConfig'

const hiddenDangerScheduledTaskApi = new HiddenDangerScheduledTaskApi()

const areaApi = new AreaApi()
const userApi = new UserApi()

export default {
  name: 'timing-job-table',
  components: {
    TableOperateButton,
    TimingBaseForm,
    TaskUnitConfig,
  },
  data() {
    return {
      controlHierarchyList: [],
      dialogShow: false,
      userList: [],
      pageNo: 1,
      pageSize: 15,
      total: 0,
      formProps: {
        editType: 'create',
      },
      formDialog: false,
      formData: {},
      areaList: [],
      unitCycleList: [],
      checkTypeList: [],
      // 设备设施清单
      tableData: [],
      loading: false,
      searchData: {
        keywords: '',
        unitCycle: null,
        areaId: undefined,
        inspectionCycle: undefined,
        inspectionType: null,
        deadlinePersonId: null,
      },
      selectionData: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '编辑',
            click: () => {
              return this.handleEvent(val, 'update')
            },
            isShow: this.$hasAccess('update') && val.planStatus === false,
          },
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '删除',
            click: () => {
              return this.handleEvent(val, 'delete')
            },
            isShow: this.$hasAccess('delete'),
          },
        ]
      }
    },
    // 排查周期
    unitCycleListMap() {
      return (val) => {
        return (
          this.unitCycleList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    checkTypeListMap() {
      return (val) => {
        return (
          this.checkTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    controlHierarchyListMap() {
      return (val) => {
        return (
          this.controlHierarchyList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
  },
  created() {
    this.searchList()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.UnitCycle',
        'DoublePreventionManagement.DataCategory.CheckType',
        'DoublePreventionManagement.DataCategory.ControlHierarchy',
      ],
      ['unitCycleList', 'checkTypeList', 'controlHierarchyList'],
      this
    )
    this.getAreaList()
    this.getUserList()
  },
  methods: {
    // 启用/停用 0 设备设施 1 作业活动 2基础管理
    changeValues(value, index, row) {
      if (!row.initialInvestigationTime || !row.deadlineForTime) {
        this.$message({
          showClose: true,
          message: '该任务不存在排查时间，不可操作',
          type: 'warning',
        })
        return
      }
      this.$confirm(`是否${value === true ? '启用' : '停用'}任务`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await hiddenDangerScheduledTaskApi.startOrClose({
            body: {
              id: row.id,
              checklistTypeEnums: 2,
              isStart: value,
            },
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            })
            this.searchList()
          }
        })
        .catch(() => {
          this.tableData[index].planStatus = !value
        })
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await userApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.userList = res.items
      }
    },
    // 保存
    async save() {
      if (this.$refs.taskUnitAdd.submitForm()) {
        const [err, res] = await hiddenDangerScheduledTaskApi.updateBasicManagementTroubleshooting({
          body: this.$refs.taskUnitAdd.handleSaveData(),
        })
        if (!err) {
          this.$message({
            showClose: true,
            message: '保存设置成功',
            type: 'success',
          })
          this.dialogShow = false
          this.searchList()
        }
      }
    },
    // 取消
    cancel() {
      this.dialogShow = false
    },
    // 多选
    handleSelection(values) {
      this.selectionData = values
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      switch (operation) {
        case 'create':
          if (!this.selectionData || this.selectionData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选记录',
              type: 'warning',
            })
            return
          }
          this.dialogShow = true
          break
        case 'update':
          if (row.planStatus === true) {
            this.$message({
              showClose: true,
              message: '请先停用任务，在进行编辑',
              type: 'warning',
            })
            return
          }
          this.initDialog(row, operation)
          break
        case 'read':
          this.initDialog(row, operation)
          break
        case 'delete':
          this.$confirm('是否确定删除', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            const [
              err,
              res,
            ] = await hiddenDangerScheduledTaskApi.deleteBasicManagementTroubleshooting({
              id: row.id,
            })
            if (!err) {
              this.$message({
                showClose: true,
                message: '删除成功',
                type: 'success',
              })
              this.searchList()
            }
          })
          break
        default:
          break
      }
    },
    // 弹窗初始化操作
    initDialog(row, operation) {
      // 没有新增获取数据
      this.formProps.editType = operation
      if (row) {
        const rowData = JSON.parse(JSON.stringify(row))
        this.$set(this, 'formData', rowData)
      } else {
        this.formData = this.$options.data().formData
      }
      this.formDialog = true
    },
    // 搜索 equip 设备设施 job 作业活动
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    resetText() {
      this.searchData = this.$options.data().searchData
      this.searchList()
    },
    async findList() {
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      const [
        err,
        res,
      ] = await hiddenDangerScheduledTaskApi.getBasicManagementTroubleshootingListAsnyc(data)

      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.loading = false
      }
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style></style>
